import React from "react";
import Organisation from "./Organisation";

const OrganizationParent = (props: any) => {
  return <Organisation {...props} />;
};

export default OrganizationParent;
